/**
 * @file
 * Provides product teaser slideshow on hover.
 */

let $productTeasers = $('.view-shop-products .product-teaser', context);

$productTeasers.once('product-teaser-slideshow').each(function() {
  let $this = $(this);
  let $slideshow = $this.find('.field-name-field-product-image .field-items');
  let slides = $slideshow.find('.field-item').length;
  let timer;

  let setImageContainerSize = function() {
    if (slides > 1) {
      $slideshow.addClass('is-slideshow');
      // We have squared product images.
      $slideshow.css({ height: $this.find('.content-box').width() });
    }
  };

  if (slides > 1) {
    setImageContainerSize();
    $slideshow.find('.field-item:first-child').addClass('field-item-first');

    // TODO: hover event doesn't work when Slick is enabled.
    $slideshow.hover(
      function() {
        clearInterval(timer);
        timer = setInterval(function() {
          $slideshow
            .find('.field-item:first-child')
            .fadeOut(100)
            .next('.field-item')
            .fadeIn(100)
            .end()
            .appendTo($slideshow);
        }, 800);
      },
      function() {
        clearInterval(timer);
      }
    );

    $slideshow.mouseleave(function() {
      $slideshow.find('.field-item').fadeOut(100);
      $slideshow.find('.field-item-first').fadeIn(100);
    });
  }

  $(window).resize(setImageContainerSize);
});
